import { render, staticRenderFns } from "./ReportJ1.vue?vue&type=template&id=336aae74&"
import script from "./ReportJ1.vue?vue&type=script&lang=js&"
export * from "./ReportJ1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports